const msrconstants = {
    unauthorized : "You are not authorized !!!",
}

export default msrconstants;